import { render } from "./QuotesEmail.vue?vue&type=template&id=54f96871"
import script from "./QuotesEmail.vue?vue&type=script&lang=js"
export * from "./QuotesEmail.vue?vue&type=script&lang=js"
script.render = render

export default script